export default __webpack_public_path__ + "static/media/tourOrg.1a683622.png";